import React, { FC } from 'react';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';

import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';
import Placeholder from './placeholder';
import { INTERNAL_URI, productHref, categoryHref } from '@helpers/route';

const getCategoryBreadcrumb = (categories: any) => {
  return _orderBy(categories, ['path', 'asc'])
    .filter((item) => item.isActive && item.id > 2)
    .map((item) => ({
      active: false,
      href: INTERNAL_URI.CATEGORY,
      as: categoryHref(_get(item, 'id'), _get(item, 'urlKey')),
      name: _get(item, 'name'),
    }));
};

type Props = {
  loading: boolean;
  error: boolean | any;
  data: any;
};

export const Breadcrumb: FC<Props> = ({ loading, error, data }) => {
  if (loading || error) {
    return <Placeholder />;
  }

  const categoriesBreadcrumb = getCategoryBreadcrumb(
    _get(data, 'product.categories')
  );

  return (
    <BreadcrumbComponent
      options={[
        ...categoriesBreadcrumb,
        {
          active: true,
          href: INTERNAL_URI.PRODUCT,
          as: productHref(_get(data, 'product.id'), _get(data, 'product.name')),
          name: _get(data, 'product.name'),
        },
      ]}
    />
  );
};

export default Breadcrumb;
